import { DataContext } from '../../data/DataContext';
import { useContext } from 'react';
import { ImgOk, ImgError } from '../../images';

const Step6 = () => {

    const { CVS } = useContext(DataContext);

    const labelOk: Array<string> = [
        '¡Todo listo!'
        , 'Hemos recibido tu información'
        , 'Nuestros ejecutivos se contactarán contigo para confirmar datos y continuar el proceso de solicitud de crédito.'
    ];

    const labelError: Array<string> = [
        '¡Ooops!',
        'Ocurrió un error, pero no te preocupes, hemos recibido tus datos',
        'Nuestros ejecutivos se contactarán contigo para confirmar datos y continuar el proceso de solicitud de crédito.'
    ];

    return (
        <div className='mt-40'>
            <div className='img-cvs'>
                {CVS.saved && <ImgOk />}
                {!CVS.saved && <ImgError />}
            </div>
            <div className='mt-40 lbl-cvs lbl-cvs-f1'>
                {CVS.saved && labelOk[0]}
                {!CVS.saved && labelError[0]}
            </div>
            <div className='mt-10 lbl-cvs lbl-cvs-f2'>
                {CVS.saved && labelOk[1]}
                {!CVS.saved && labelError[1]}
            </div>
            <div className='mt-20 lbl-cvs lbl-cvs-f3'>
                {CVS.saved && labelOk[2]}
                {!CVS.saved && labelError[2]}
            </div>
        </div>
    );
}

export { Step6 };